import { isEqual } from 'lodash';
import { BulkProvisioningFilters } from 'atoms/filters/bulk-provisioning.ts';

export const useHasActiveProvisioningFilters = (filters: BulkProvisioningFilters) => {
  return Object.entries(filters).some(([key, value]) => {
    if (key === 'source' && isEqual(value, [])) {
      return false;
    }

    if (
      (key === 'uploadDateFrom' && value === null) ||
      (key === 'uploadDateTo' && value === null)
    ) {
      return false;
    }

    return value !== '';
  });
};
